// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessageIconHeader_wrapper__jW9tA","iconActive":"MessageIconHeader_iconActive__1YpM2"};